/* =============================================================================
   lala / pdp-gallery.js
   Layers zoom + lightbox onto the existing [data-gallery] slider (theme.js):
     • desktop (≥900px): click the image → modal (large image + thumbnails +
       arrows + click-to-zoom & drag-pan)
     • mobile (<900px): tap the image → zoom 2× at the point, drag to pan,
       tap again to reset. No lightbox.
   Navigation is driven through the slider's own thumbnail buttons, so the
   slider's paging/scroll logic (theme.js initGallery) stays untouched.
   Dependency-free.
   ============================================================================= */
(function () {
  "use strict";
  var mqMobile = window.matchMedia("(max-width: 899px)");

  function sizedSrc(src, w) {
    if (!src) return src;
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, "$1" + w);
    if (/cdn\.shopify\.com/.test(src)) return src + (src.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
    return src;
  }
  function baseSrc(img) { return (img && (img.getAttribute("data-zoom") || img.currentSrc || img.getAttribute("src") || img.src)) || ""; }
  function clamp(v, min, max) { return v < min ? min : v > max ? max : v; }
  function ready(fn) { if (document.readyState !== "loading") fn(); else document.addEventListener("DOMContentLoaded", fn); }

  ready(function () { document.querySelectorAll("[data-gallery]").forEach(init); });

  function init(gal) {
    if (gal.getAttribute("data-gallery-zoom")) return;
    gal.setAttribute("data-gallery-zoom", "1");
    var track = gal.querySelector("[data-gallery-track]");
    if (!track) return;
    var slides = Array.prototype.slice.call(gal.querySelectorAll("[data-gallery-slide]"));
    var imgs = slides.map(function (s) { return s.querySelector("img"); }).filter(Boolean);
    if (imgs.length < 1) return;
    var srcs = imgs.map(baseSrc);
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll("[data-gallery-thumb]"));

    function currentIndex() {
      for (var i = 0; i < thumbs.length; i++) if (thumbs[i].getAttribute("aria-current") === "true") return i;
      return Math.round(track.scrollLeft / (track.clientWidth || 1)) || 0;
    }
    function goTo(n) {
      var len = imgs.length; n = ((n % len) + len) % len;
      if (thumbs[n]) thumbs[n].click();
      else track.scrollTo({ left: n * track.clientWidth, behavior: "smooth" });
      return n;
    }

    var zoom = setupMobileZoom(gal, track, imgs, currentIndex);
    var modal = buildModal(srcs, goTo);

    // reset the in-place zoom whenever the slider moves (swipe / arrow / thumb)
    track.addEventListener("scroll", function () { if (zoom) zoom.reset(); }, { passive: true });

    // click: desktop opens the modal; mobile is handled by touch (zoom-in-place)
    gal.addEventListener("click", function (e) {
      if (e.target.closest("[data-gallery-prev],[data-gallery-next],[data-gallery-thumb]")) return;
      if (mqMobile.matches) return;
      if (!e.target.closest("[data-gallery-slide]")) return;
      modal.open(currentIndex());
    });
  }

  /* ---- mobile: tap to zoom 2× at the point, drag to pan, tap to reset ------ */
  function setupMobileZoom(gal, track, imgs, currentIndex) {
    var scale = 1, tx = 0, ty = 0, w = 0, h = 0, active = null, zoomed = false;
    var startX = 0, startY = 0, baseTx = 0, baseTy = 0, moved = false, panning = false;
    function apply() { if (active) active.style.transform = "translate(" + tx + "px," + ty + "px) scale(" + scale + ")"; }
    function clampPan() { var mx = (scale - 1) * w / 2, my = (scale - 1) * h / 2; tx = clamp(tx, -mx, mx); ty = clamp(ty, -my, my); }
    function reset() {
      if (active) { active.style.transition = "transform .2s ease"; active.style.transform = ""; }
      zoomed = false; scale = 1; tx = ty = 0; active = null; gal.classList.remove("is-zoomed");
    }
    function zoomAt(cx, cy) {
      active = imgs[currentIndex()]; if (!active) return;
      var r = active.getBoundingClientRect(); w = r.width; h = r.height; scale = 2;
      tx = -scale * (cx - r.left - w / 2); ty = -scale * (cy - r.top - h / 2); clampPan();
      active.style.transformOrigin = "center center"; active.style.transition = "transform .2s ease"; apply();
      zoomed = true; gal.classList.add("is-zoomed");
    }
    gal.addEventListener("touchstart", function (e) {
      if (!mqMobile.matches) return; var t = e.touches[0]; startX = t.clientX; startY = t.clientY; moved = false;
      if (zoomed) { baseTx = tx; baseTy = ty; panning = true; if (active) active.style.transition = "none"; }
    }, { passive: true, capture: true });
    gal.addEventListener("touchmove", function (e) {
      if (!mqMobile.matches) return; var t = e.touches[0]; var dx = t.clientX - startX, dy = t.clientY - startY;
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) moved = true;
      if (zoomed && panning) { e.stopPropagation(); if (e.cancelable) e.preventDefault(); tx = baseTx + dx; ty = baseTy + dy; clampPan(); apply(); }
    }, { passive: false, capture: true });
    gal.addEventListener("touchend", function (e) {
      if (!mqMobile.matches) return; panning = false;
      if (e.target.closest("[data-gallery-prev],[data-gallery-next],[data-gallery-thumb]")) return;
      if (!moved) { if (zoomed) reset(); else zoomAt(startX, startY); }
    }, { passive: true, capture: true });
    return { reset: reset };
  }

  /* ---- desktop modal: large image + thumbnails + arrows + zoom/pan --------- */
  function buildModal(srcs, goTo) {
    var el = document.createElement("div");
    el.className = "laz"; el.setAttribute("aria-hidden", "true");
    el.innerHTML =
      '<div class="laz__backdrop" data-laz-close></div>' +
      '<div class="laz__dialog" role="dialog" aria-modal="true" aria-label="Nuotraukos">' +
        '<button class="laz__x" type="button" data-laz-close aria-label="Uždaryti"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<div class="laz__frame">' +
          '<button class="laz__nav laz__prev" type="button" data-laz-prev aria-label="Ankstesnė"><svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<div class="laz__stage" data-laz-stage><img class="laz__img" data-laz-img alt=""></div>' +
          '<button class="laz__nav laz__next" type="button" data-laz-next aria-label="Kita"><svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '</div>' +
        '<div class="laz__thumbs" data-laz-thumbs></div>' +
      '</div>';
    document.body.appendChild(el);

    var stage = el.querySelector("[data-laz-stage]"), img = el.querySelector("[data-laz-img]"), thumbsWrap = el.querySelector("[data-laz-thumbs]");
    var idx = 0, savedY = 0, z = { on: false, scale: 1, tx: 0, ty: 0, w: 0, h: 0 };
    var tbtns = srcs.map(function (src, i) {
      var b = document.createElement("button"); b.type = "button"; b.className = "laz__thumb"; b.setAttribute("aria-label", "Nuotrauka " + (i + 1));
      var t = document.createElement("img"); t.src = sizedSrc(src, 200); t.alt = ""; t.loading = "lazy"; b.appendChild(t);
      b.addEventListener("click", function () { show(i); }); thumbsWrap.appendChild(b); return b;
    });
    function resetZoom() { z.on = false; z.scale = 1; z.tx = 0; z.ty = 0; img.style.transform = ""; stage.classList.remove("is-zoomed"); }
    function show(i) {
      idx = ((i % srcs.length) + srcs.length) % srcs.length; resetZoom();
      img.src = sizedSrc(srcs[idx], 2048);
      for (var k = 0; k < tbtns.length; k++) tbtns[k].classList.toggle("is-on", k === idx);
      var b = tbtns[idx];
      if (b && thumbsWrap.scrollWidth > thumbsWrap.clientWidth + 4) {
        var br = b.getBoundingClientRect(), sr = thumbsWrap.getBoundingClientRect();
        thumbsWrap.scrollTo({ left: thumbsWrap.scrollLeft + (br.left - sr.left) - (sr.width - br.width) / 2, behavior: "smooth" });
      }
    }
    function open(i) {
      show(i); savedY = window.scrollY || 0;
      document.body.style.position = "fixed"; document.body.style.top = -savedY + "px"; document.body.style.left = "0"; document.body.style.right = "0"; document.body.style.width = "100%";
      el.classList.add("is-open"); el.setAttribute("aria-hidden", "false"); var x = el.querySelector(".laz__x"); if (x) x.focus({ preventScroll: true });
    }
    function close() {
      el.classList.remove("is-open"); el.setAttribute("aria-hidden", "true");
      document.body.style.position = ""; document.body.style.top = ""; document.body.style.left = ""; document.body.style.right = ""; document.body.style.width = "";
      window.scrollTo(0, savedY); resetZoom(); goTo(idx);
    }
    function zoomAt(cx, cy) {
      var r = img.getBoundingClientRect(); z.w = r.width; z.h = r.height; z.scale = 2;
      z.tx = clamp(-2 * (cx - r.left - r.width / 2), -r.width / 2, r.width / 2);
      z.ty = clamp(-2 * (cy - r.top - r.height / 2), -r.height / 2, r.height / 2); z.on = true;
      stage.classList.add("is-zoomed"); img.style.transformOrigin = "center center";
      img.style.transform = "translate(" + z.tx + "px," + z.ty + "px) scale(2)";
    }
    var dragging = false, dsx = 0, dsy = 0, btx = 0, bty = 0, movedM = false;
    img.addEventListener("mousedown", function (e) { if (!z.on) return; dragging = true; movedM = false; dsx = e.clientX; dsy = e.clientY; btx = z.tx; bty = z.ty; e.preventDefault(); });
    window.addEventListener("mousemove", function (e) {
      if (!dragging) return; var dx = e.clientX - dsx, dy = e.clientY - dsy; if (Math.abs(dx) > 3 || Math.abs(dy) > 3) movedM = true;
      var mx = (z.scale - 1) * z.w / 2, my = (z.scale - 1) * z.h / 2; z.tx = clamp(btx + dx, -mx, mx); z.ty = clamp(bty + dy, -my, my);
      img.style.transform = "translate(" + z.tx + "px," + z.ty + "px) scale(" + z.scale + ")";
    });
    window.addEventListener("mouseup", function () { dragging = false; });
    img.addEventListener("click", function (e) { if (movedM) { movedM = false; return; } if (z.on) resetZoom(); else zoomAt(e.clientX, e.clientY); });
    el.addEventListener("click", function (e) { if (e.target.closest("[data-laz-close]")) close(); });
    el.querySelector("[data-laz-prev]").addEventListener("click", function () { show(idx - 1); });
    el.querySelector("[data-laz-next]").addEventListener("click", function () { show(idx + 1); });
    document.addEventListener("keydown", function (e) {
      if (!el.classList.contains("is-open")) return;
      if (e.key === "Escape") close(); else if (e.key === "ArrowLeft") show(idx - 1); else if (e.key === "ArrowRight") show(idx + 1);
    });
    return { open: open };
  }
})();
